module.exports = __webpack_public_path__ + "img/gnu_smart_thumbnail.d69beebd.jpg";